// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__CK_HN","toggleDisabled":"Toggle_toggleDisabled__D5FKo"};